module.exports = __webpack_public_path__ + "static/Dazzle_icon-41b6fac9e988eef4062e9ccaf3a38816.webp";